(() => {
  if (typeof window.customElements.get('bundle-form') !== 'undefined') { return }
  window.customElements.define('bundle-form', class BundleForm extends HTMLElement {
    constructor () {
      super()

      this.bundleMainAtcBtn = this.querySelector('[data-bundle-form-atc]')
      this.bundleDiscountPercentage = parseInt(this.dataset.bundleDiscountPercentage, 10)

      this.initBundleForm()
    }

    initBundleForm () {
      try {
        this.checkDisabledState()
        this.observeMutations()
        this.handleAddToCartClick()
      } catch (error) {
        console.error('There was an issue with the Bundle Form snippet:', error)
      }
    }

    checkDisabledState () {
      const bundleItemBuyButtons = this.querySelectorAll('buy-buttons')
      let mainButtonDisabled = false

      bundleItemBuyButtons.forEach((bundleItemBuyButton) => {
        const atcButton = bundleItemBuyButton.querySelector('button[type="submit"]')

        if (atcButton && atcButton.disabled) {
          mainButtonDisabled = true
        }
      })

      this.bundleMainAtcBtn.disabled = mainButtonDisabled
      this.bundleMainAtcBtn.classList.toggle('button--subdued', mainButtonDisabled)
    }

    observeMutations () {
      const config = {
        attributes: true,
        childList: true,
        subtree: true
      }

      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.target === this.bundleMainAtcBtn) {
            continue
          } else {
            this.checkDisabledState()
            break
          }
        }
      })

      observer.observe(this, config)
    }

    handleAddToCartClick () {
      this.bundleMainAtcBtn.addEventListener('click', () => { 
        this.addBundleItemsToCart()
      })
    }

    async addBundleItemsToCart () {
      this.bundleMainAtcBtn.disabled = true
      this.bundleMainAtcBtn.setAttribute('aria-busy', true)

      const bundleTitleEl = document.querySelector('[data-product-title]')
      const bundleTitle = bundleTitleEl ? bundleTitleEl.innerHTML : 'Bundle'
      const uniqueBundleProperty = `bundle-group--${Date.now() + Math.floor(Math.random() * 1000)}`
      const bundleItemForms = this.querySelectorAll('form[is="product-form"]')
      const bundleData = {
        'items': []
      }

      bundleItemForms.forEach((bundleItemForm, index) => {
        const bundleItemVariantID = bundleItemForm.querySelector('input[name="id"]').value
        const bundleItemNumber = index + 1
        bundleData.items.push({
          'id': bundleItemVariantID,
          'quantity': 1,
          'properties': {
            'Bundle': bundleTitle,
            '_bundle_item_number': bundleItemNumber,
            '_bundle_id': uniqueBundleProperty,
            '_bundle_count': bundleItemForms.length,
            '_bundle_discount': this.bundleDiscountPercentage
          }
        })
      })

      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        body: JSON.stringify(bundleData),
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json'
        }
      })

      this.bundleMainAtcBtn.disabled = false
      this.bundleMainAtcBtn.removeAttribute('aria-busy')

      const responseJson = await response.json()

      if (response.ok) {
        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json()

        this.dispatchEvent(new CustomEvent('variant:add', {
          bubbles: true,
          detail: {
            items: responseJson.hasOwnProperty('items') ? responseJson['items'] : [responseJson],
            cart: cartContent
          }
        }))
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            cart: cartContent
          }
        }))
        document.dispatchEvent(new CustomEvent('cart:refresh'))
      } else {
        this.dispatchEvent(new CustomEvent('cart:error', {
          bubbles: true,
          detail: {
            error: responseJson['description']
          }
        }))
        document.dispatchEvent(new CustomEvent('cart:refresh'))
        this.onCartError(responseJson['description'])
      }
    }

    onCartError(errorDetail) {
      const errorBanner = document.createElement("div");
      errorBanner.classList.add("banner", "banner--error", "justify-center");
      errorBanner.setAttribute("role", "alert");
      errorBanner.style.gridColumn = "1/-1";
      errorBanner.style.marginBottom = "1rem";
      errorBanner.innerHTML = `
        <svg role="presentation" focusable="false" width="18" height="18" class="offset-icon icon icon-error" style="--icon-height: 18px" viewBox="0 0 18 18">
          <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
          <path d="M5.29289 6.70711L11.2929 12.7071L12.7071 11.2929L6.70711 5.29289L5.29289 6.70711ZM6.70711 12.7071L12.7071 6.70711L11.2929 5.2929L5.29289 11.2929L6.70711 12.7071Z" fill="#ffffff"></path>
        </svg>
        
        <p>${errorDetail}</p>
      `;
      this.bundleMainAtcBtn.before(errorBanner);
      setTimeout(async () => {
        await errorBanner.animate({ opacity: [1, 0] }, { duration: 250, fill: "forwards" }).finished;
        errorBanner.remove();
      }, 5e3);
    }
  })
})()
